module.exports = __webpack_public_path__ + "img/Albania.e70facc8.png";